import { useCallback } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { assignActionModal, hideModal, showModal } from '../../../redux/actions/modal'
import { IRootState } from '../../../redux/types'

export const useModal = () => {
  return {
    modal: useSelector((state: IRootState) => state.modal, shallowEqual)
  }
}

export const useShowModal = (props: any) => {
  const dispatch = useDispatch()
  return useCallback(
    (params = {}) => {
      dispatch(showModal({ ...props }))
    },
    [dispatch]
  )
}

export const useErrorModal = ({ props }: any) => {
  const dispatch = useDispatch()
  return {
    handleShowErrorModal: useCallback(
      error => {
        // dispatch(showErrorModalAction({ ...props }));
      },
      [dispatch]
    )
  }
}

export const useConfirmationModal = (paramFunction: any) => {
  const dispatch = useDispatch()
  return useCallback(() => {
    dispatch(assignActionModal(paramFunction))
  }, [dispatch])
}

export const useInfoModal = () => {
  return {
    // Create your reusable info modals logic
  }
}

export const useHideModal = () => {
  const dispatch = useDispatch()
  const handleOnClose = useCallback(() => {
    dispatch(hideModal())
  }, [dispatch])
  return {
    handleOnClose
  }
}
